/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Applications_Applied_DateInputs */

const en_applications_applied_date = /** @type {(inputs: Applications_Applied_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Applied ${i?.date}`)
};

const de_applications_applied_date = /** @type {(inputs: Applications_Applied_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Beworben am ${i?.date}`)
};

const fr_applications_applied_date = /** @type {(inputs: Applications_Applied_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Postulé le ${i?.date}`)
};

const es_applications_applied_date = /** @type {(inputs: Applications_Applied_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Postulado el ${i?.date}`)
};

const it_applications_applied_date = /** @type {(inputs: Applications_Applied_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Candidata il ${i?.date}`)
};

const nl_applications_applied_date = /** @type {(inputs: Applications_Applied_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gesolliciteerd op ${i?.date}`)
};

const pl_applications_applied_date = /** @type {(inputs: Applications_Applied_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wysłano ${i?.date}`)
};

const fi_applications_applied_date = /** @type {(inputs: Applications_Applied_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Haettu ${i?.date}`)
};

const da_applications_applied_date = /** @type {(inputs: Applications_Applied_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ansøgt ${i?.date}`)
};

const sv_applications_applied_date = /** @type {(inputs: Applications_Applied_DateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ansökt ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Applied {date}" |
*
* @param {Applications_Applied_DateInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const applications_applied_date = /** @type {((inputs: Applications_Applied_DateInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applications_Applied_DateInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applications_applied_date(inputs)
	if (locale === "fr") return fr_applications_applied_date(inputs)
	if (locale === "es") return es_applications_applied_date(inputs)
	if (locale === "it") return it_applications_applied_date(inputs)
	if (locale === "nl") return nl_applications_applied_date(inputs)
	if (locale === "pl") return pl_applications_applied_date(inputs)
	if (locale === "fi") return fi_applications_applied_date(inputs)
	if (locale === "da") return da_applications_applied_date(inputs)
	if (locale === "sv") return sv_applications_applied_date(inputs)
	return en_applications_applied_date(inputs)
});